import { render, staticRenderFns } from "./taskList.vue?vue&type=template&id=7995714d&scoped=true&"
import script from "./taskList.vue?vue&type=script&lang=ts&"
export * from "./taskList.vue?vue&type=script&lang=ts&"
import style0 from "./taskList.vue?vue&type=style&index=0&id=7995714d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7995714d",
  null
  
)

export default component.exports